if (!customElements.get('read-more')) {
  customElements.define(
    'read-more',
    class ReadMore extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('click', this.onClickHandler.bind(this));
      }

      onClickHandler(event) {
        const el = event.target;
        const truncatedText = el.dataset.truncatedText;
        const fullText = el.dataset.fullText;

        if (el.className.includes('is-truncated')) {
          el.innerHTML = fullText;
          el.classList.remove('is-truncated');
        } else {
          el.innerHTML = truncatedText;
          el.classList.add('is-truncated');
        }
      }
    }
  );
}
